(function () {
  'use strict';

  angular
    .module('requestRespectedReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('requestRespectedReport', {
        url: '/request-respected-report',
        views:{
          'requestRespectedReportView': {
            templateUrl: 'request-respected-report/views/request-respected-report.tpl.html',
            controller: 'requestRespectedReportCtrl',
            controllerAs: 'requestRespectedReport'
          }
        }
      });
  }
}());
